import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"50\" cy=\"50\" r=\"50\" fill=\"url(#paint0_linear_2002_83962)\"></circle><path d=\"M58.3941 30H41.6258C34.3422 30 30 34.3421 30 41.6257V58.3739C30 65.6774 34.3422 70.0195 41.6258 70.0195H58.3741C65.6578 70.0195 69.9999 65.6774 69.9999 58.3939V41.6257C70.0199 34.3421 65.6778 30 58.3941 30ZM59.5747 45.4075L48.2291 56.7531C47.9489 57.0332 47.5688 57.1933 47.1686 57.1933C46.7684 57.1933 46.3882 57.0332 46.108 56.7531L40.4452 51.0903C39.8649 50.51 39.8649 49.5495 40.4452 48.9693C41.0255 48.389 41.986 48.389 42.5663 48.9693L47.1686 53.5715L57.4537 43.2865C58.034 42.7062 58.9944 42.7062 59.5747 43.2865C60.155 43.8668 60.155 44.8072 59.5747 45.4075Z\" fill=\"white\"></path><defs><linearGradient id=\"paint0_linear_2002_83962\" x1=\"45\" y1=\"45\" x2=\"107.692\" y2=\"116.704\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#801434\"></stop><stop offset=\"1\" stop-color=\"#801434\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})